module.exports = __webpack_public_path__ + "static/media/cream.862e9e3a.png";